export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'fltgrdPseudoNDNahrada';
export const NAME = 'PseudoNdNahrada';
